import { Provider } from '@angular/core';
import { AuthInterceptor } from '@/common/auth/auth.interceptor';
import { UnprocessableErrorInterceptor } from '@/common/http/errors.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export const HttpInterceptorsProvider: Provider = [
	{
		provide: HTTP_INTERCEPTORS,
		useClass: AuthInterceptor,
		multi: true,
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: UnprocessableErrorInterceptor,
		multi: true,
	},
];
